import React, { useContext } from 'react';

import LoadingPage from '../../components/LoadingPage/LoadingPage';
import ChatContextProvider from './ChatContextProvider';
import ChatContext from './ChatContext';

const withChatContextProvider = (Component) => (props) => (
  <ChatContextProvider>
    <Component {...props} />
  </ChatContextProvider>
);

const withChatContextProviderReady = (Component) => (props) => {
  const { isReady } = useContext(ChatContext);
  return isReady ? <Component {...props} /> : <LoadingPage />;
};

export {
  withChatContextProvider,
  withChatContextProviderReady,
};
